export default function PlayIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
    >
      <path
        d="M12.0417 7.52003L1.91832 1.33333C1.83305 1.28122 1.73544 1.25277 1.63553 1.2509C1.53562 1.24902 1.43701 1.2738 1.34985 1.32269C1.26269 1.37157 1.19013 1.44278 1.13963 1.52901C1.08912 1.61524 1.0625 1.71337 1.0625 1.8133V14.1867C1.0625 14.2866 1.08912 14.3848 1.13963 14.471C1.19013 14.5572 1.26269 14.6284 1.34985 14.6773C1.43701 14.7262 1.53562 14.751 1.63553 14.7491C1.73544 14.7472 1.83305 14.7188 1.91832 14.6667L12.0417 8.47996C12.1239 8.42972 12.1918 8.35919 12.239 8.27514C12.2861 8.1911 12.3109 8.09636 12.3109 8C12.3109 7.90364 12.2861 7.80889 12.239 7.72485C12.1918 7.64081 12.1239 7.57028 12.0417 7.52003Z"
        stroke="#FE7235"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
